import { defineStore } from '@sunrise/pinia'

import { MetaStore } from './metaStoreModule.interface'

export const useMetaStore = defineStore('meta', {
    state: (): MetaStore => ({
        privacyManagerId: null,
    }),
})
